export class PartsSupplierPartModel {
  sku: string;
  cost: number;
  isActive: boolean;
}
